// extracted by mini-css-extract-plugin
export default {"svg-icon":"SvgIcon_svg-icon__uUdpE"};